import { mergeRegister } from '@lexical/utils';
import { RedoIcon, UndoIcon } from '@medly-components/icons';
import { CAN_REDO_COMMAND, CAN_UNDO_COMMAND, COMMAND_PRIORITY_CRITICAL, REDO_COMMAND, UNDO_COMMAND } from 'lexical';
import { FC, useEffect, useState } from 'react';

import { IS_APPLE } from 'constants/platform';

import { HistoryButtonsProps } from './types';

export const HistoryButtons: FC<HistoryButtonsProps> = ({ isEditable, activeEditor }) => {
    const [canUndo, setCanUndo] = useState(false);
    const [canRedo, setCanRedo] = useState(false);

    useEffect(() => {
        return mergeRegister(
            activeEditor.registerCommand<boolean>(
                CAN_UNDO_COMMAND,
                payload => {
                    setCanUndo(payload);
                    return false;
                },
                COMMAND_PRIORITY_CRITICAL
            ),
            activeEditor.registerCommand<boolean>(
                CAN_REDO_COMMAND,
                payload => {
                    setCanRedo(payload);
                    return false;
                },
                COMMAND_PRIORITY_CRITICAL
            )
        );
    }, [activeEditor]);

    return (
        <>
            <button
                type="button"
                disabled={!canUndo || !isEditable}
                onClick={() => activeEditor.dispatchCommand(UNDO_COMMAND, undefined)}
                title={IS_APPLE ? 'Undo (⌘Z)' : 'Undo (Ctrl+Z)'}
                className="toolbar-item spaced"
                aria-label="Undo"
            >
                <UndoIcon />
            </button>
            <button
                type="button"
                disabled={!canRedo || !isEditable}
                onClick={() => activeEditor.dispatchCommand(REDO_COMMAND, undefined)}
                title={IS_APPLE ? 'Redo (⌘Y)' : 'Redo (Ctrl+Y)'}
                className="toolbar-item"
                aria-label="Redo"
            >
                <RedoIcon />
            </button>
        </>
    );
};
